// extracted by mini-css-extract-plugin
export default {"imageWrapper":"cJ-z","twoColumnImage":"dJ-z"};